import { FilterHandler } from '@btime/react-contexts'
import { capitalizeAllIfLower } from '@btime/helpers'
import React from 'react'

import { CompanyAvatar } from '../../../../components/presentation/Avatar'
import { Title } from '../../../../components/presentation/Text'
import { useGroups } from '../../_load/GroupsLoader'
import CardSelector from '../../../../components/form/CardSelector'
import ControlBar from './ControlBar'
import TagPicker from '../../../../components/form/TagPicker'

const GroupCardSelector = ({ option, ...props }) => {
  const group = option.origin
  const head = <CompanyAvatar company={group} />
  const body = (
    <div>
      <Title size="h6" bold noMargin>
        {option.label}
      </Title>
    </div>
  )

  return <CardSelector head={head} body={body} width="25%" widthOnSm="50%" {...props} />
}

const GroupPicker = props => {
  const group = useGroups()
  const options = group.map(item => ({
    label: capitalizeAllIfLower(item.name),
    value: props.idField ? item : item.id,
    origin: item
  }))

  if (props.value == 'all') return false

  return <TagPicker options={options} Selector={GroupCardSelector} {...props} />
}

const Wrapper = ({ selectedLabel, useSelectAll, children, ...props }) => (
  <FilterHandler>
    <ControlBar
      selectedLabel={selectedLabel}
      header={children}
      useSelectAll={useSelectAll}
      value={props.value}
      onChange={props.onChange}
      disabledLoader={props.value == 'all'}
    >
      <GroupPicker {...props} />
    </ControlBar>
  </FilterHandler>
)

export default Wrapper
